import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'corporateActionsTransform' })
export class CorporateActionsIdTransform implements PipeTransform {

    transform(id: number): string {
        return this.idToCorpActionString(id);
    }

    private idToCorpActionString(id: number) : string {
        switch (id) {
            case 1: {
                return "Expired Dividend Rights"; 
            }
            case 2: {
                return "CUSIP / ISIN Change"; 
            }
            case 3: {
                return "Merger / Acquisition"; 
            }
            case 4: {
                return "Payback of principal or early redemption"; 
            }
            case 5: {
                return "Stock Split"; 
            }
            case 6: {
                return "Stock Dividend"; 
            }
            case 7: {
                return "Subscribable Rights Issue"; 
            }
            case 8: {
                return "Spin Off"; 
            }
            case 9: {
                return "Dividends Rights Issue"; 
            }
            case 10: {
                return "Split"; 
            }
            case 11: {
                return "Subscription"; 
            }
            case 12: {
                return "TENDER OFFER / ISSUE"; 
            }
            case 13: {
                return "Stock Split"; 
            }
            case 14: {
                return "Stock Dividend"; 
            }
            case 15: {
                return "Delisted"; 
            }
            case 16: {
                return "Spin Off"; 
            }
            case 17: {
                return "Contract Consolidation"; 
            }
            case 18: {
                return "Oversubscription Rights Issue"; 
            }
            case 19: {
                return "Stock Split"; 
            }
            case 20: {
                return "T-Bill Maturity"; 
            }
            default: {
                return " - ";  
            }
        }
    }
}